import {
  MessageSquare, Route, Bot, Zap, Tag, Ticket, ArrowUpDown, Database, Send, Eye,
  GitBranch, Shield, HeartPulse,
} from 'lucide-react';

export const PHASE_COLORS = {
  input: { bg: 'bg-blue-50', border: 'border-blue-200', text: 'text-blue-700', icon: MessageSquare },
  orchestration: { bg: 'bg-amber-50', border: 'border-amber-200', text: 'text-amber-700', icon: Route },
  knowledge: { bg: 'bg-purple-50', border: 'border-purple-200', text: 'text-purple-700', icon: Database },
  agent: { bg: 'bg-green-50', border: 'border-green-200', text: 'text-green-700', icon: Bot },
  ticketing: { bg: 'bg-red-50', border: 'border-red-200', text: 'text-red-700', icon: Ticket },
  output: { bg: 'bg-cyan-50', border: 'border-cyan-200', text: 'text-cyan-700', icon: Send },
  hitl: { bg: 'bg-orange-50', border: 'border-orange-200', text: 'text-orange-700', icon: Eye },
  coordination: { bg: 'bg-indigo-50', border: 'border-indigo-200', text: 'text-indigo-700', icon: GitBranch },
  supervision: { bg: 'bg-rose-50', border: 'border-rose-200', text: 'text-rose-700', icon: Shield },
  heartbeat: { bg: 'bg-teal-50', border: 'border-teal-200', text: 'text-teal-700', icon: HeartPulse },
  custom: { bg: 'bg-zinc-50', border: 'border-zinc-200', text: 'text-zinc-700', icon: Zap },
};

export const EVENT_LABELS = {
  message_received: 'Mensaje Recibido',
  whatsapp_ingest: 'WA Ingesta (bridge)',
  media_attachments: 'Adjuntos STT/OCR',
  classification: 'Clasificacion',
  routing_decision: 'Decision de Routing',
  label_assigned: 'Label Asignado',
  ticket_created: 'Ticket Creado',
  tarea_creada_por_un_agente: 'Tarea creada por el agente',
  kb_gate_decision: 'Gate KB (llm)',
  rag_search: 'Busqueda RAG',
  memoria_de_persona_leida: 'Memoria de la persona (lectura)',
  memoria_de_persona_actualizada: 'Memoria de la persona (aprendizaje)',
  memoria_organizacional_actualizada: 'Memoria organizacional (aprendizaje)',
  metadata_manual_correction: 'Metadatos (correccion manual)',
  agent_processing: 'Procesamiento Agente',
  agent_response: 'Respuesta Agente',
  coordinator_post_turn: 'Coordinador post-turno',
  message_sent: 'Mensaje Enviado',
  hitl_action: 'Accion HITL',
  tool_execution: 'Ejecucion Tool',
  kb_investigation_tool: 'Investigacion KB (tool)',
  workspace_kernel_tool: 'Workspace (tool)',
  harness_control: 'Harness control',
  harness_turn_graph: 'Harness workflow (grafo)',
  turn_health: 'Turn Health (harness)',
  llm_call: 'Llamada LLM',
  heartbeat_reminder: 'Heartbeat recordatorio',
  heartbeat_tick: 'Heartbeat tick (silencio)',
  heartbeat_escalation: 'Heartbeat escalacion',
  heartbeat_ticket_created: 'Heartbeat ticket creado',
  heartbeat_notification: 'Heartbeat notificacion equipo',
};

export const STAGE_LABELS = {
  classification: 'Clasificacion',
  kb_gate: 'Gate KB',
  agent: 'Agente linea',
  coordinator_post_turn: 'Coord. ticket',
};

export const GUIDE_ROW_LABELS = {
  routing_guidance: 'Routing',
  ticket_guidance: 'Tickets',
  vocabulary_guidance: 'Vocabulario global',
  ticket_coordination_guidance: 'Coordinacion ticket',
  sla_followup_guidance: 'SLA y seguimiento',
  kb_usage_guidance: 'Uso KB (gate)',
};
